/* Galerie produit mobile (≤ 749px) — points de navigation façon Respire.
   Ajoute sous l'image principale de la fiche produit une rangée de points
   (un par image) : le point actif suit le défilement au doigt, et un appui
   sur un point fait défiler jusqu'à l'image correspondante. Mise en forme :
   assets/component-pdp-gallery-mobile.css (points masqués au-delà de 749px).
   Tous supports : les visuels de la galerie ne sont pas déplaçables par
   glisser-déposer (draggable=false, complète le CSS pour Firefox).
   Chargé par sections/pdp-fixes.liquid. */
(function () {
  function slidesOf(list) {
    return list.querySelectorAll(':scope > .product__media-item');
  }

  function lockImages(gallery) {
    gallery.querySelectorAll('.product__media-item img').forEach(function (img) {
      if (img.getAttribute('draggable') !== 'false') img.setAttribute('draggable', 'false');
    });
  }

  function init(gallery) {
    lockImages(gallery);
    if (gallery.dataset.pdpDots) return;
    var viewer = gallery.querySelector('slider-component[id^="GalleryViewer-"]');
    var list = viewer && viewer.querySelector('.product__media-list');
    if (!list) return;
    var count = slidesOf(list).length;
    if (count < 2) return;
    gallery.dataset.pdpDots = 'true';

    var wrap = document.createElement('div');
    wrap.className = 'pdp-gallery-dots';
    var dots = [];

    for (var i = 0; i < count; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'pdp-gallery-dots__dot';
      dot.setAttribute('aria-label', 'Afficher l’image ' + (i + 1) + ' sur ' + count);
      dot.addEventListener('click', (function (index) {
        return function () {
          list.scrollTo({ left: index * list.clientWidth, behavior: 'smooth' });
        };
      })(i));
      wrap.appendChild(dot);
      dots.push(dot);
    }
    viewer.appendChild(wrap);

    var current = -1;
    function update() {
      var width = list.clientWidth || 1;
      var index = Math.min(count - 1, Math.max(0, Math.round(list.scrollLeft / width)));
      if (index === current) return;
      current = index;
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === index);
        if (n === index) {
          d.setAttribute('aria-current', 'true');
        } else {
          d.removeAttribute('aria-current');
        }
      });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    }

    list.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function initAll() {
    document.querySelectorAll('[id$="__main"] media-gallery').forEach(init);
  }

  function start() {
    initAll();
    // Galerie re-rendue (changement de variante sur certains produits, éditeur de thème).
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        initAll();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
